export const formatHyphens = (str) => {
    return str.replace(/(<a[^>]*>.*?<\/a>)|-/g, (_match, group) => {
        if (group) {
          return group;
        } else {
          return `\u2011`;
        }
    });
}